module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ammerswil-b1f39ff54af721c09ad00c0cfc91527e.svg";